export default "__VITE_ASSET__HuU1Gi8Q__"